import { render, staticRenderFns } from "./RoleManagementAllocation.vue?vue&type=template&id=47fcb228&scoped=true&"
import script from "./RoleManagementAllocation.vue?vue&type=script&lang=js&"
export * from "./RoleManagementAllocation.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementAllocation.vue?vue&type=style&index=0&id=47fcb228&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fcb228",
  null
  
)

export default component.exports